import { render, staticRenderFns } from "./AnnotationPanel.vue?vue&type=template&id=3959ee42&scoped=true"
import script from "./AnnotationPanel.vue?vue&type=script&lang=js"
export * from "./AnnotationPanel.vue?vue&type=script&lang=js"
import style0 from "./AnnotationPanel.vue?vue&type=style&index=0&id=3959ee42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959ee42",
  null
  
)

export default component.exports